<section class="how-to-buy" id="how-to-buy">
  <div class="container">
    <div class="how-to-buy-container d-flex flex-column">
      <div class="title-section">
        <h2 class="section-title mx-auto text-center">
          {{ 'how-to-buy.title' | translate }}
        </h2>
        <p class="section-desc mb-0">{{ 'how-to-buy.desc' | translate }}</p>
      </div>
      <div class="accepted-payments">
        <p class="section-desc text-center">Accepted Payment Methods</p>
        <div class="currencies d-none d-md-flex flex-row gap-3 gap-md-4 justify-content-center">
          <div class="currency d-flex flex-column justify-content-center align-items-center"
            *ngFor="let currency of currencies">
            <img src="/assets/images/svg-icons/{{currency.img}}.svg" [alt]="currency.txt" loading="lazy">
            <span class="font-14 text-grey fw-bold">{{currency.txt}}</span>
          </div>
        </div>
        <div class="marquee d-block d-md-none">
          <div class="track">
            <div class="content currencies">
              <div class="currency d-flex flex-column justify-content-center align-items-center"
                *ngFor="let currency of currencies">
                <img src="/assets/images/svg-icons/{{currency.img}}.svg" [alt]="currency.txt" loading="lazy">
                <span class="font-14 text-grey">{{currency.txt}}</span>
              </div>

              <div class="currency d-flex  flex-column justify-content-center align-items-center"
                *ngFor="let currency of currencies">
                <img src="/assets/images/svg-icons/{{currency.img}}.svg" [alt]="currency.txt" loading="lazy">
                <span class="font-14 text-grey">{{currency.txt}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="steps d-flex flex-column flex-md-row">
        <div class="step d-flex flex-column justify-content-center align-items-center"
          *ngFor="let step of steps; let index = index">
          <div class="img-wrapper">
            <img src="/assets/images/svg-icons/{{step.img}}.svg" [alt]="step.title | translate" loading="lazy">
          </div>
          <span class="step-num">{{index + 1}}</span>
          <div class="step-content d-flex flex-column">
            <span class="text-center font-24 text-grey">{{step.title | translate}}</span>
            <span class="text-center font-16">{{step.desc | translate}}</span>
          </div>
        </div>
      </div>
      <div class="btn btn-primary rounded mx-auto" (click)="showWidget('home')">{{
        'how-to-buy.buy_now'
        |
        translate }}</div>
    </div>
  </div>
</section>